import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';
import { Observable } from 'rxjs';

export interface UserCredentials {
    userId: number;
    isNurseContract: boolean;
    isRecruiter: boolean;
    hasPilotPermission: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorAuthService extends MarginCalculatorBaseService {
    private _userCredentials: UserCredentials;

    constructor(private readonly _http: HttpClient) {
        super();
    }

    get userCredentials(): UserCredentials {
        return this._userCredentials;
    }

    getUserCredentials(): Observable<UserCredentials> {
        return this._http
            .get<UserCredentials>(`${this.coreApiPath}/margin-calculator/user-credential`)
            .pipe(map((response) => (this._userCredentials = response)));
    }
}
